import { render } from "./RuiAuthWrapper.vue?vue&type=template&id=5b6d89ab"
import script from "./RuiAuthWrapper.vue?vue&type=script&lang=ts"
export * from "./RuiAuthWrapper.vue?vue&type=script&lang=ts"

import "./RuiAuthWrapper.vue?vue&type=style&index=0&id=5b6d89ab&lang=scss"
script.render = render

export default script